<div class="empty-state" [ngClass]="typeGrid ? 'empty-state--' + typeGrid : ''">
    <div class="empty-state__image">
        <ng-container *ngIf="emptyFullPage; else emptySeparateBlock">
            <img class="empty-state__main-img" src="assets/images/empty-states/base.png" alt="" />
            <img
                class="empty-state__subimage"
                [ngClass]="'empty-state__subimage--' + iconName"
                src="assets/images/empty-states/{{ iconName }}.png"
                alt=""
            />
        </ng-container>

        <ng-template #emptySeparateBlock>
            <img class="empty-state__main-img" src="assets/images/empty-states/empty-state-icon.svg" alt="" />
        </ng-template>
    </div>

    <div class="empty-state__info">
        <ng-content></ng-content>
    </div>
</div>
